<template>
    <div>
        <!-- 树形表格-->
        <tree-table class="treetable" :show-row-hover="false" border show-index index-text="#" :data="tablelist" :columns="columns" :selection-type="false" :expand-type="false">
            <!--<template slot="isok" slot-scope="scope">
                <i class="el-icon-success" v-if="scope.row.cat_deleted === false" style="color: lightgreen"></i>
                <i class="el-icon-error" v-else style="color: red"></i>
            </template>
            <template slot="order" slot-scope="scope">
                <el-tag size="mini" v-if="scope.row.cat_level === 0">一级</el-tag>
                <el-tag size="mini" v-else-if="scope.row.cat_level === 1" type="success">二级</el-tag>
                <el-tag size="mini" v-else type="warning">三级</el-tag>
            </template>
            <template slot="opt" slot-scope="scope">
                <el-button type="primary" size="min" icon="el-icon-edit" circle @click="showEditDialog(scope.row.cat_id)">编辑</el-button>
                <el-button type="danger" size="min" icon="el-icon-delete" circle @click="deleteEditDialog(scope.row.cat_id)">删除</el-button>
            </template>-->
        </tree-table>
        <!--分页区域-->
        <el-pagination
                v-show="total>0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="queryInfo.pagenum"
                :page-sizes="[10, 20, 30, 40]"
                :page-size="queryInfo.pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
        </el-pagination>
    </div>
</template>

<script>
export default {
    name: "",
    props: {
        tableData: {
            type: Object,
            default() {
                return {
                    tablelist: [],
                    columns: [],
                    queryInfo: {
                        pagenum: 1,
                        pagesize: 10
                    },
                    total: 0
                }
            }
        }
    },
    watch: {
        tableData: {
            handler: function () {
                this.initTable()
            },
            deep: true
        }
    },
    data () {
        return {
            // 数据
            tablelist: this.tableData.tablelist,
            // 列
            columns: this.tableData.columns,
            // 查询条件
            queryInfo: {
                pagenum: 1,
                pagesize: 10
            },
            // 总数据条数
            total: this.tableData.total
        }
    },
    methods: {
        initTable () {
            console.log(this.tableData)
            this.tablelist = this.tableData.tablelist
            this.columns = this.tableData.columns
            this.queryInfo = this.tableData.queryInfo
            this.total = this.tableData.total
        },
        // 监听pagesize 改变的事件
        handleSizeChange(newSize) {
            this.queryInfo.pagesize = newSize
            // this.getCateList()
        },
        // 监听页码值 改变的事件
        handleCurrentChange(newPage) {
            this.queryInfo.pagenum = newPage
            // this.getCateList()
        }
    }
}
</script>

<style scoped>

</style>
